export const safeJsonParse = (string) => {
    try {
        return JSON.parse(string);
    } catch (e) {
        console.warn('not valid json', e);
        return undefined;
    }
};